export const resolveThemeColor = (
  lightColor: string | undefined,
  darkColor: string | undefined,
  isDarkAppearance?: boolean,
): string | undefined => {
  const light = lightColor?.trim();
  const dark = darkColor?.trim();
  if (isDarkAppearance) {
    return dark || light || undefined;
  }
  return light || dark || undefined;
};
